export default __webpack_public_path__ + "static/Edwin Luo Resume-048e0d26609bc9ee7ccd68889ffe9850.pdf";